import React, { useEffect, useState, useContext, useRef } from "react";
import ColorsMain from "../../colors/ColorsMain.js";
import { UtilContext } from "../../context/UtilContext";
import { GLOBAL_LANGUAGE } from "../../language/language";

const SearchableSelect = ({
    list,
    setSelectOpcion,
    error = false,
    label = "",
    readOnly,
    image = false
}) => {
    const { language } = useContext(UtilContext); // Usa el contexto de Auth
    const t = GLOBAL_LANGUAGE[language] || GLOBAL_LANGUAGE.es;

    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredOptions, setFilteredOptions] = useState(list || []);
    const [selectedOption, setSelectedOption] = useState(
        label || t.inputselect_search.placeholder
    );

    // Ref para el contenedor del dropdown
    const dropdownRef = useRef(null);

    // Filtrar las opciones según el término de búsqueda
    useEffect(() => {
        if (searchTerm) {
            setFilteredOptions(
                list.filter((option) =>
                    option.name.toLowerCase().includes(searchTerm.toLowerCase())
                )
            );
        } else {
            setFilteredOptions(list);
        }
    }, [searchTerm, list]);

    // Manejar el clic fuera del dropdown para cerrarlo
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        // Añadir el event listener
        document.addEventListener("mousedown", handleClickOutside);

        // Limpiar el event listener al desmontar el componente
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleOptionClick = (option) => {
        setSelectedOption(option.name);
        setSelectOpcion(option.code);
        setIsOpen(false); // Cierra el menú después de seleccionar una opción
    };

    const handleToggleDropdown = (e) => {
        if (readOnly) return;
        setIsOpen((prev) => !prev);
    };

    const dropdownMenu = (
        <div
            ref={dropdownRef}
            className="shadow-lg ring-opacity-5 z-50 rounded-xl transition-all duration-500 transform scale-100 opacity-100"
            style={{
                background: "#2B2B33",
            }}
        >
            {/* Campo de búsqueda */}
            <div className="p-2">
                <input
                    type="text"
                    placeholder={t.inputselect_search.search_placeholder}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full px-3 py-2 rounded-md border border-gray-300"
                    style={{
                        background: ColorsMain.bgInput,
                        color: ColorsMain.texttMain,
                    }}
                />
            </div>

            {/* Lista de opciones */}
            <div className="max-h-60 w-full overflow-y-auto px-2 pt-2">
                {filteredOptions?.length > 0 ? (
                    filteredOptions?.map((option, index) => (
                        <button
                            key={index}
                            onClick={() => handleOptionClick(option)}
                            className="w-full text-left text-sm py-2 px-3 rounded-md flex-row flex items-center"
                            style={{
                                background: "#2B2B33",
                                color: ColorsMain.texttMain,
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = "#ffffff"; // Fondo blanco al hover
                                e.target.style.color = "#000000"; // Texto negro al hover
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#2B2B33'; // Fondo original
                                e.target.style.color = ColorsMain.texttMain; // Texto original
                            }}
                        >
                            {image && <div className="w-6 h-6  mr-4 rounded-full overflow-hidden flex items-center justify-center ">
                                <img src={option.url} alt="Bandera" className="w-full h-full object-cover" />
                            </div>}

                            {option.name || option.range}
                        </button>
                    ))
                ) : (
                    <div
                        className="text-center py-2"
                        style={{ color: ColorsMain.texttMain }}
                    >
                        Sin resultados
                    </div>
                )}
            </div>
        </div>
    );

    return (
        <div className="relative inline-block text-left w-full">
            {/* Botón que simula el input select */}
            <button
                type="button"
                onClick={handleToggleDropdown}
                className="inline-flex justify-between w-full px-2 py-2 font-medium rounded-md items-center transition-colors duration-300 ease-in-out"
                style={{
                    background: ColorsMain.bgInput,
                    color: ColorsMain.texttMain,
                    borderWidth: 1,
                    borderColor: error ? ColorsMain.errorBorder : ColorsMain.borderGray,
                }}
            >
                {selectedOption}
                <svg
                    className={`w-5 h-5 transition-transform duration-500 ${isOpen ? "rotate-180" : "rotate-0"
                        }`}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    style={{ pointerEvents: "none" }}
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                    />
                </svg>
            </button>

            {/* Renderizar el dropdown solo cuando isOpen sea true */}
            {isOpen && (
                <div
                    className="absolute w-full"
                    style={{
                        top: "-10px", // Ajusta la posición aquí
                        zIndex: 1000,  // Asegura que el dropdown esté por encima de otros elementos
                    }}
                >
                    {dropdownMenu}
                </div>
            )}
        </div>
    );
};

export default SearchableSelect;
